import {Component, OnInit} from '@angular/core';
import {InvoiceTemplateBase} from '../invoce-template-base';

@Component({
    selector: 'eci-domestic-air-invoice-form',
    templateUrl: './domestic-air-invoice-form.component.html',
    styleUrls: ['./domestic-air-invoice-form.component.scss']
})
export class DomesticAirInvoiceFormComponent extends InvoiceTemplateBase implements OnInit {

    ngOnInit(): void {
        this.model = {
            ...this.template,
            ...this.invoice,
            customerCompany: {
                ...this.template.customerCompany,
                ...this.invoice.customerCompany
            }
        };
    }

}
